export default class InvalidEntityJWTError extends Error {}
